import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import '../../assets/styles/DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [staySidebarOpen, setStaySidebarOpen] = useState(false);

  const toggleSidebar = () => {
    if (!staySidebarOpen) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const toggleStaySidebarOpen = () => {
    setStaySidebarOpen(!staySidebarOpen);
  };

  return (
    <div className={`dashboard ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        staySidebarOpen={staySidebarOpen}
        toggleStaySidebarOpen={toggleStaySidebarOpen}
      />
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        stayOpen={staySidebarOpen}
        toggleStayOpen={toggleStaySidebarOpen}
      />
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;


